import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {observer} from "mobx-react-lite";
import {Button, InputLabel, ButtonProps, PropsInput} from "@/components"
import {LoginEmail} from "@/models/auth";
import {ILoginEmail} from "@/types/auth";

import {useEnterKeydown, useFormikConfig, useSubmitting} from "../hooks";
import {onSubmitLoginEmail} from "../submits"



export const FormLogin = observer(() => {
    const [isFocus, setIsFocus] = useState<boolean>(false);
    const navigate = useNavigate();
    const onSubmit = () => onSubmitLoginEmail(formik, navigate);
    const initialValues: ILoginEmail = new LoginEmail();
    const validationSchema = (initialValues as LoginEmail).validationSchema();
    const formik = useFormikConfig<ILoginEmail>(initialValues, onSubmit, validationSchema);
    useSubmitting(formik);
    useEnterKeydown(isFocus, onSubmit, setIsFocus);

    const loginProps: PropsInput = {
        type: 'text',
        name: 'username',
        label: 'Логин',
        error: formik.touched.username && formik.errors.username,
        placeholder: 'Введите ваш e-mail',
        colorError: 'red',
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values.username,
        autoComplete: 'on',
    }
    const passwordProps: PropsInput = {
        type: 'password',
        name: 'password',
        label: 'Пароль',
        error: formik.touched.password && formik.errors.password,
        placeholder: 'Введите пароль',
        colorError: 'red',
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values.password,
        autoComplete: 'off',
        onFocus: () => setIsFocus(true)
    }
    const buttonProps: ButtonProps = {
        disabled: !formik.isValid || formik.isSubmitting,
        type: 'submit'

    }
    return (
        <form onSubmit={formik.handleSubmit}>
            <InputLabel {...loginProps}/>
            <InputLabel {...passwordProps}/>
            <Button {...buttonProps}>Войти</Button>
        </form>
    )
});

export default FormLogin;